import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useBreakpoints from '#client/hooks/useBreakpoints';

export const Quote = () => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();
  return (
    <Stack
      alignItems="center"
      spacing={2}
    >
      <Text
        color="primary"
        position="relative"
        size={isDesktop ? 'xl' : 'lg'}
        sx={{
          textAlign: isDesktop ? 'left' : 'center',
          maxWidth: isDesktop ? '100%' : '51%'
        }}
        weight="medium"
      >
        <Text
          component="span"
          family="secondary"
          position="absolute"
          sx={{
            color: 'background.green.main',
            fontSize: '110px',
            top: '10px',
            left: '-41px'
          }}
        >
          “
        </Text>
        <Text
          component="span"
          position="relative"
        >
          It was very{' '}
          <Text
            component="span"
            sx={{
              backgroundColor: 'background.green.main'
            }}
          >
            simple
          </Text>{' '}
          to set up my whole entire{' '}
          <Text
            component="span"
            sx={{
              backgroundColor: 'background.green.main'
            }}
          >
            banking
          </Text>{' '}
          system&quot;
        </Text>
      </Text>
      <Text
        color="primary"
        size="md"
        weight="medium"
      >
        Marisa, ZenBusiness customer
      </Text>
    </Stack>
  );
};
